// PARAQTA — Monthly Wrapped (Stage 7.5 Session 3).
// Бір айдың толық рефлексиясы. Жан дос ғана.
// PNG export → Web Share API (Stories-ке share).

import { api } from '../../core/api.js';
import { show } from '../../core/router.js';
import { toast } from '../../utils/toast.js';

const KK_MONTH_ABBR_C = ['Қаң','Ақп','Нау','Сәу','Мам','Мау','Шіл','Там','Қыр','Қаз','Қар','Жел'];
const KK_MONTH_OF = ['қаңтар','ақпан','наурыз','сәуір','мамыр','маусым','шілде','тамыз','қыркүйек','қазан','қараша','желтоқсан'];
const KK_WEEKDAY = ['дүйсенбі','сейсенбі','сәрсенбі','бейсенбі','жұма','сенбі','жексенбі'];

let _state = { year: 0, month: 0, data: null, priorMonths: [], isPromo: false };

function esc(s) {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

const root = () => document.getElementById('pg-wrapped-monthly');

function _prevMonth(y, m) {
  if (m === 1) return { y: y - 1, m: 12 };
  return { y, m: m - 1 };
}

function _formatDate(iso) {
  if (!iso) return '';
  const s = String(iso).slice(0, 10);
  const [y, mo, d] = s.split('-').map(Number);
  if (!y || !mo || !d) return s;
  return `${d} ${KK_MONTH_OF[mo - 1]}`;
}

function _weekdayOf(iso) {
  if (!iso) return '';
  const s = String(iso).slice(0, 10);
  const d = new Date(s + 'T00:00:00');
  return KK_WEEKDAY[(d.getDay() + 6) % 7];
}

function _peakLabel(h) {
  if (h == null) return '';
  if (h >= 18 || h < 4) return 'кешкі';
  if (h >= 12) return 'күндізгі';
  return 'таңғы';
}

export async function loadMonthlyWrapped() {
  const r = root();
  if (!r) return;
  // Determine target month from query string OR default to previous month
  let target = null;
  try {
    const hash = window.location.hash || '';
    const m = hash.match(/wrapped-monthly[\/=:](\d{4})[\/=:-](\d{1,2})/);
    if (m) target = { y: parseInt(m[1], 10), m: parseInt(m[2], 10) };
  } catch (_) {}
  if (!target) {
    const t = new Date();
    target = _prevMonth(t.getFullYear(), t.getMonth() + 1);
  }
  _state.year = target.y;
  _state.month = target.m;
  r.innerHTML = '<div style="padding:60px 20px;text-align:center;color:color-mix(in srgb,var(--ink) 50%,transparent);font-size:13px;">Есеп дайындалуда…</div>';
  try {
    const resp = await api(`/api/wrapped/monthly/${target.y}/${target.m}`);
    if (resp?.status === 'premium_required') {
      const { showPremiumLockModal } = await import('../premium-lock/modal.js');
      showPremiumLockModal('wrapped');
      try { show('profile'); } catch (_) {}
      return;
    }
    if (resp?.status !== 'ok' || !resp.wrapped) {
      r.innerHTML = '<div style="padding:60px 20px;text-align:center;color:color-mix(in srgb,var(--ink) 50%,transparent);font-size:13px;">Қате — қайта көрейік</div>';
      return;
    }
    _state.data = resp.wrapped;
    _state.isPromo = !!resp.is_promo;
    // Fetch prior months for archive list (3 prior)
    await _fetchPriorMonths(target.y, target.m, 3);
    _render();
  } catch (e) {
    console.error('loadMonthlyWrapped failed', e);
    r.innerHTML = '<div style="padding:60px 20px;text-align:center;color:#A85048;font-size:13px;">Қате</div>';
  }
}

async function _fetchPriorMonths(y, m, count) {
  _state.priorMonths = [];
  let cur = { y, m };
  for (let i = 0; i < count; i++) {
    cur = _prevMonth(cur.y, cur.m);
    try {
      const r = await api(`/api/wrapped/monthly/${cur.y}/${cur.m}`);
      if (r?.status === 'ok' && r.wrapped) {
        _state.priorMonths.push({ y: cur.y, m: cur.m, data: r.wrapped });
      }
    } catch (_) {}
  }
}

function _render() {
  const r = root();
  if (!r || !_state.data) return;
  const d = _state.data;
  const cmpCls = d.pct_change > 0 ? 'up' : (d.pct_change < 0 ? 'down' : 'neutral');
  const cmpColor = cmpCls === 'up' ? '#3A5C3C' : (cmpCls === 'down' ? '#A85048' : 'rgba(28,26,22,.55)');
  const cmpBg = cmpCls === 'up' ? 'rgba(58,92,60,.1)' : (cmpCls === 'down' ? 'rgba(168,80,72,.1)' : 'rgba(28,26,22,.05)');
  const cmpSign = d.pct_change > 0 ? '▲ +' : (d.pct_change < 0 ? '▼ ' : '— ');
  const prevMonthName = (() => {
    const p = _prevMonth(d.year, d.month);
    return KK_MONTH_OF[p.m - 1];
  })();
  const cmpLabel = d.pct_change == null ? '' : `${cmpSign}${Math.abs(d.pct_change)}% ${prevMonthName}дан`;

  // Top books rows
  const topBooks = (d.top_books || []).slice(0, 3).map((b, i) => `
    <div style="display:flex;align-items:center;gap:12px;padding:12px 14px;background:#FFFFFF;border:.5px solid rgba(28,26,22,.08);border-radius:12px;">
      <div style="font-family:'PT Serif',Georgia,serif;font-size:20px;font-weight:700;color:#8B5E34;min-width:24px;text-align:center;">${i+1}</div>
      <div style="flex:1;min-width:0;">
        <div style="font-family:'PT Serif',Georgia,serif;font-size:13px;font-weight:700;color:#1C1A16;line-height:1.25;">«${esc(b.title)}»</div>
        ${b.author ? `<div style="font-size:11px;color:rgba(28,26,22,.55);margin-top:2px;font-family:'Cormorant Garamond',serif;font-style:italic;">${esc(b.author)}</div>` : ''}
      </div>
      <div style="font-family:'PT Serif',Georgia,serif;font-size:14px;font-weight:700;color:#8B5E34;">${b.pages}<small style="font-size:10px;font-family:Onest,sans-serif;color:#8B5E34;"> бет</small></div>
    </div>
  `).join('');

  // Book of the month (top 1) — for share frame
  const heroBook = (d.top_books && d.top_books[0]) || null;
  const heroCover = heroBook ? esc((heroBook.title || '?')[0]) : '?';

  // Insights
  const insightHtml = (() => {
    const items = [];
    if (d.top_day) {
      const wd = _weekdayOf(d.top_day.date) || d.top_day.weekday || '';
      const label = _formatDate(d.top_day.date);
      items.push(`
        <div style="background:#FFFFFF;border:.5px solid rgba(28,26,22,.08);border-radius:12px;padding:12px 14px;display:flex;align-items:center;gap:12px;">
          <div style="width:36px;height:36px;border-radius:10px;flex-shrink:0;background:linear-gradient(135deg,rgba(201,169,110,.2),rgba(139,94,52,.06));display:flex;align-items:center;justify-content:center;font-size:16px;">🏆</div>
          <div style="flex:1;min-width:0;">
            <div style="font-size:11.5px;color:rgba(28,26,22,.55);font-weight:500;margin-bottom:2px;">Ең көп оқыған күн</div>
            <div style="font-family:'PT Serif',Georgia,serif;font-size:14px;font-weight:700;color:#1C1A16;line-height:1.25;"><span style="color:#8B5E34;">${d.top_day.pages} бет</span> · ${label}</div>
            ${wd ? `<div style="font-size:10.5px;color:rgba(28,26,22,.55);margin-top:2px;font-family:'Cormorant Garamond',serif;font-style:italic;">${wd}</div>` : ''}
          </div>
        </div>
      `);
    }
    if (d.longest_session) {
      const lsDate = _formatDate(d.longest_session.date);
      items.push(`
        <div style="background:#FFFFFF;border:.5px solid rgba(28,26,22,.08);border-radius:12px;padding:12px 14px;display:flex;align-items:center;gap:12px;">
          <div style="width:36px;height:36px;border-radius:10px;flex-shrink:0;background:linear-gradient(135deg,rgba(201,169,110,.2),rgba(139,94,52,.06));display:flex;align-items:center;justify-content:center;font-size:16px;">⚡</div>
          <div style="flex:1;min-width:0;">
            <div style="font-size:11.5px;color:rgba(28,26,22,.55);font-weight:500;margin-bottom:2px;">Ең ұзақ сессия</div>
            <div style="font-family:'PT Serif',Georgia,serif;font-size:14px;font-weight:700;color:#1C1A16;line-height:1.25;"><span style="color:#8B5E34;">${esc(d.longest_session.text)}</span> · ${lsDate}</div>
            <div style="font-size:10.5px;color:rgba(28,26,22,.55);margin-top:2px;font-family:'Cormorant Garamond',serif;font-style:italic;">бір отырыста</div>
          </div>
        </div>
      `);
    }
    if (d.peak_hour != null) {
      const peak = d.peak_hour;
      const lbl = _peakLabel(peak);
      const endHr = Math.min(peak + 2, 23);
      items.push(`
        <div style="background:#FFFFFF;border:.5px solid rgba(28,26,22,.08);border-radius:12px;padding:12px 14px;display:flex;align-items:center;gap:12px;">
          <div style="width:36px;height:36px;border-radius:10px;flex-shrink:0;background:linear-gradient(135deg,rgba(201,169,110,.2),rgba(139,94,52,.06));display:flex;align-items:center;justify-content:center;font-size:16px;">🌙</div>
          <div style="flex:1;min-width:0;">
            <div style="font-size:11.5px;color:rgba(28,26,22,.55);font-weight:500;margin-bottom:2px;">Қашан көп оқыдың</div>
            <div style="font-family:'PT Serif',Georgia,serif;font-size:14px;font-weight:700;color:#1C1A16;line-height:1.25;">${lbl} <span style="color:#8B5E34;">${String(peak).padStart(2,'0')}:00 — ${String(endHr).padStart(2,'0')}:00</span></div>
          </div>
        </div>
      `);
    }
    return items.join('');
  })();

  // Genres
  const genres = (d.genres || []).slice(0, 4);
  const maxGenre = Math.max(1, ...genres.map(g => g.cnt));
  const genresHtml = genres.map(g => `
    <div style="display:flex;align-items:center;gap:10px;background:#FFFFFF;border:.5px solid rgba(28,26,22,.08);border-radius:10px;padding:10px 14px;">
      <div style="font-family:'PT Serif',Georgia,serif;font-size:12.5px;font-weight:700;color:#1C1A16;min-width:88px;">${esc(g.genre)}</div>
      <div style="flex:1;height:7px;background:rgba(28,26,22,.05);border-radius:4px;overflow:hidden;"><div style="height:100%;width:${Math.round(g.cnt/maxGenre*100)}%;background:linear-gradient(to right,#8B5E34,#C9A96E);border-radius:4px;"></div></div>
      <div style="font-family:'PT Serif',Georgia,serif;font-size:13px;font-weight:700;color:#8B5E34;min-width:30px;text-align:right;">${g.cnt}</div>
    </div>
  `).join('');

  // Prior months
  const priorHtml = (_state.priorMonths || []).map(p => `
    <div data-action="open-wrapped-monthly" data-year="${p.y}" data-month="${p.m}" style="display:flex;align-items:center;justify-content:space-between;padding:11px 14px;background:rgba(28,26,22,.03);border-radius:10px;cursor:pointer;">
      <div style="font-size:12px;font-weight:600;color:#1C1A16;">${esc(p.data.month_name)}<small style="font-size:10px;color:rgba(28,26,22,.55);font-weight:500;margin-left:6px;">${p.y}</small></div>
      <div style="font-family:'PT Serif',Georgia,serif;font-size:13px;font-weight:700;color:#8B5E34;">${p.data.pages} бет</div>
    </div>
  `).join('');

  r.innerHTML = `
    <div style="background:#F7F2EA;min-height:100vh;">
      <!-- Top bar -->
      <div style="display:flex;justify-content:space-between;align-items:center;padding:14px 16px;background:#F7F2EA;position:sticky;top:0;z-index:20;border-bottom:.5px solid rgba(28,26,22,.08);">
        <button data-action="profile-back" style="background:none;border:none;cursor:pointer;font-family:Onest,sans-serif;font-size:12px;font-weight:600;color:#1C1A16;display:flex;align-items:center;gap:6px;">← Профиль</button>
        <button data-action="monthly-wrapped-share" style="background:var(--ac);color:#fff;border:none;cursor:pointer;font-family:Onest,sans-serif;font-size:11.5px;font-weight:600;padding:8px 14px;border-radius:999px;">📤 Бөлісу</button>
      </div>

      <!-- ═══ SHARE FRAME (PNG capture) ═══ -->
      <div data-field="share-frame" style="background:linear-gradient(160deg,#FBF7EF 0%,#F1E9D8 100%);padding:32px 22px 28px;position:relative;overflow:hidden;">
        <div style="position:absolute;top:-40px;right:-40px;width:200px;height:200px;background:radial-gradient(circle,rgba(233,169,73,.18) 0%,transparent 65%);pointer-events:none;"></div>

        <div style="font-size:9.5px;letter-spacing:2px;color:#8B5E34;font-weight:600;margin-bottom:6px;">PARAQTA · оқу журналы</div>
        <div style="font-family:'PT Serif',Georgia,serif;font-size:30px;font-weight:700;color:#1C1A16;line-height:1;">${esc(d.month_name)} <span style="color:#8B5E34;">${d.year}</span></div>
        <div style="font-family:'Cormorant Garamond',serif;font-style:italic;font-size:14px;color:rgba(28,26,22,.55);margin-top:6px;">шамың айдың әр аптасында жанды</div>

        <div style="display:flex;align-items:center;gap:18px;margin:24px 0 18px;">
          <div style="width:90px;height:120px;flex-shrink:0;position:relative;display:flex;align-items:flex-end;justify-content:center;">
            <div style="position:absolute;top:0;left:50%;transform:translateX(-50%);width:80px;height:80px;background:radial-gradient(circle,rgba(233,169,73,.5) 0%,transparent 65%);pointer-events:none;"></div>
            <svg viewBox="0 0 90 120" style="width:100%;height:100%;" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="mw-wax" x1="0" x2="1" y1="0" y2="0">
                  <stop offset="0%" stop-color="#D8B987"/><stop offset="50%" stop-color="#C9A96E"/><stop offset="100%" stop-color="#8B5E34"/>
                </linearGradient>
                <radialGradient id="mw-flame" cx="0.5" cy="0.6" r="0.6">
                  <stop offset="0%" stop-color="#FFF8E0"/><stop offset="40%" stop-color="#FFE599"/>
                  <stop offset="80%" stop-color="#E9A949"/><stop offset="100%" stop-color="#8B5E34" stop-opacity="0.6"/>
                </radialGradient>
              </defs>
              <ellipse cx="45" cy="115" rx="22" ry="3" fill="#8B5E34" opacity="0.22"/>
              <rect x="30" y="44" width="30" height="69" rx="3.5" fill="url(#mw-wax)"/>
              <rect x="33" y="46" width="3.5" height="64" rx="1.5" fill="#FBF7EF" opacity="0.4"/>
              <line x1="45" y1="44" x2="45" y2="32" stroke="#1C1A16" stroke-width="1.6"/>
              <ellipse cx="45" cy="23" rx="10.5" ry="16" fill="url(#mw-flame)"/>
              <ellipse cx="45" cy="25" rx="4.5" ry="9" fill="#FFF8E0"/>
            </svg>
          </div>
          <div style="flex:1;">
            <div style="font-family:'PT Serif',Georgia,serif;font-size:56px;font-weight:700;color:#8B5E34;line-height:1;">${d.pages}</div>
            <div style="font-size:13px;color:rgba(28,26,22,.55);margin-top:4px;letter-spacing:.02em;font-weight:600;">бет</div>
            ${d.pct_change != null ? `<div style="display:inline-flex;align-items:center;gap:5px;margin-top:10px;padding:4px 10px;background:${cmpBg};border-radius:999px;font-size:11px;font-weight:700;color:${cmpColor};">${esc(cmpLabel)}</div>` : ''}
          </div>
        </div>

        <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:24px;padding-top:18px;border-top:.5px solid rgba(139,94,52,.18);">
          <div style="text-align:center;">
            <div style="font-family:'PT Serif',Georgia,serif;font-size:22px;font-weight:700;color:#1C1A16;line-height:1;">${esc(d.time_text || '0м')}</div>
            <div style="font-size:10.5px;color:rgba(28,26,22,.55);margin-top:5px;font-weight:600;">уақыт</div>
          </div>
          <div style="text-align:center;">
            <div style="font-family:'PT Serif',Georgia,serif;font-size:22px;font-weight:700;color:#1C1A16;line-height:1;">${d.books}</div>
            <div style="font-size:10.5px;color:rgba(28,26,22,.55);margin-top:5px;font-weight:600;">кітап</div>
          </div>
          <div style="text-align:center;">
            <div style="font-family:'PT Serif',Georgia,serif;font-size:22px;font-weight:700;color:#1C1A16;line-height:1;">${d.active_days}<small style="font-size:12px;font-family:Onest,sans-serif;font-weight:600;color:#1C1A16;">/${d.days_in_month}</small></div>
            <div style="font-size:10.5px;color:rgba(28,26,22,.55);margin-top:5px;font-weight:600;">белсенді күн</div>
          </div>
        </div>

        ${heroBook ? `
        <div style="background:#fff;border:.5px solid rgba(28,26,22,.08);border-radius:14px;padding:14px;display:flex;align-items:center;gap:14px;">
          <div style="width:54px;height:78px;flex-shrink:0;border-radius:6px;background:linear-gradient(135deg,#C9A96E,#8B5E34);display:flex;align-items:center;justify-content:center;color:#fff;font-family:'PT Serif',Georgia,serif;font-size:20px;font-weight:700;box-shadow:0 4px 12px rgba(139,94,52,.18);">${heroCover}</div>
          <div style="flex:1;min-width:0;">
            <div style="font-size:10px;letter-spacing:.5px;color:#8B5E34;font-weight:600;margin-bottom:4px;">Айдың кітабы</div>
            <div style="font-family:'PT Serif',Georgia,serif;font-size:16px;font-weight:700;color:#1C1A16;line-height:1.25;margin-bottom:3px;">«${esc(heroBook.title)}»</div>
            ${heroBook.author ? `<div style="font-size:11px;color:rgba(28,26,22,.55);font-family:'Cormorant Garamond',serif;font-style:italic;">${esc(heroBook.author)}</div>` : ''}
          </div>
          <div style="font-family:'PT Serif',Georgia,serif;font-size:20px;font-weight:700;color:#8B5E34;">${heroBook.pages}</div>
        </div>` : ''}
      </div>

      <!-- Below frame -->
      <div style="padding:24px 16px 40px;">

        ${topBooks ? `
          <div style="font-family:'PT Serif',Georgia,serif;font-size:12px;color:#8B5E34;font-weight:600;margin:18px 4px 10px;">Айдың топ кітаптары</div>
          <div style="display:flex;flex-direction:column;gap:8px;">${topBooks}</div>
        ` : ''}

        ${insightHtml ? `
          <div style="font-family:'PT Serif',Georgia,serif;font-size:12px;color:#8B5E34;font-weight:600;margin:18px 4px 10px;">Айдың сәттері</div>
          <div style="display:flex;flex-direction:column;gap:8px;">${insightHtml}</div>
        ` : ''}

        ${genresHtml ? `
          <div style="font-family:'PT Serif',Georgia,serif;font-size:12px;color:#8B5E34;font-weight:600;margin:18px 4px 10px;">Жанрлар</div>
          <div style="display:flex;flex-direction:column;gap:8px;">${genresHtml}</div>
        ` : ''}

        ${priorHtml ? `
          <div style="font-family:'PT Serif',Georgia,serif;font-size:12px;color:#8B5E34;font-weight:600;margin:18px 4px 10px;">Алдыңғы айлар</div>
          <div style="display:flex;flex-direction:column;gap:6px;">${priorHtml}</div>
        ` : ''}

        <div style="margin-top:24px;padding:16px;background:linear-gradient(135deg,rgba(201,169,110,.18),rgba(139,94,52,.06));border:.5px solid rgba(139,94,52,.25);border-radius:14px;text-align:center;">
          <div style="font-family:'PT Serif',Georgia,serif;font-size:14px;font-weight:700;color:#1C1A16;margin-bottom:6px;">📷 Жан досыңмен бөліс</div>
          <div style="font-size:11.5px;color:rgba(28,26,22,.55);font-family:'Cormorant Garamond',serif;font-style:italic;margin-bottom:12px;">сурет жасап Instagram-ға, Telegram-ге</div>
          <button data-action="monthly-wrapped-share" style="display:inline-block;padding:10px 22px;background:var(--ac);color:#fff;border:none;border-radius:999px;font-size:12px;font-weight:600;cursor:pointer;font-family:Onest,sans-serif;">Сурет жасап жіберу →</button>
        </div>

      </div>
    </div>
  `;
}

// Candle SVG used inside the PNG composition
const CANDLE_PNG_SVG = `
  <svg viewBox="0 0 90 120" style="width:100%;height:100%;position:relative;z-index:2;" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="png-wax" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0%" stop-color="#D8B987"/>
        <stop offset="50%" stop-color="#C9A96E"/>
        <stop offset="100%" stop-color="#8B5E34"/>
      </linearGradient>
      <radialGradient id="png-flame" cx="0.5" cy="0.6" r="0.6">
        <stop offset="0%" stop-color="#FFF8E0"/>
        <stop offset="40%" stop-color="#FFE599"/>
        <stop offset="80%" stop-color="#E9A949"/>
        <stop offset="100%" stop-color="#8B5E34" stop-opacity="0.6"/>
      </radialGradient>
    </defs>
    <ellipse cx="45" cy="115" rx="22" ry="3" fill="#8B5E34" opacity="0.22"/>
    <rect x="30" y="44" width="30" height="69" rx="3.5" fill="url(#png-wax)"/>
    <rect x="33" y="46" width="3.5" height="64" rx="1.5" fill="#FBF7EF" opacity="0.4"/>
    <line x1="45" y1="44" x2="45" y2="32" stroke="#1C1A16" stroke-width="1.6"/>
    <ellipse cx="45" cy="23" rx="10.5" ry="16" fill="url(#png-flame)"/>
    <ellipse cx="45" cy="25" rx="4.5" ry="9" fill="#FFF8E0"/>
  </svg>
`;

function _buildPngComposition(d) {
  // Instagram Stories 9:16 — 540×960 (×2 scale → 1080×1920)
  const cmpCls = d.pct_change > 0 ? 'up' : (d.pct_change < 0 ? 'down' : 'neutral');
  const cmpColor = cmpCls === 'up' ? '#3A5C3C' : (cmpCls === 'down' ? '#A85048' : 'rgba(28,26,22,.55)');
  const cmpBg = cmpCls === 'up' ? 'rgba(58,92,60,.12)' : (cmpCls === 'down' ? 'rgba(168,80,72,.12)' : 'rgba(28,26,22,.06)');
  const cmpSign = d.pct_change > 0 ? '▲ +' : (d.pct_change < 0 ? '▼ ' : '— ');
  const prevMonthName = (() => {
    const p = _prevMonth(d.year, d.month);
    return KK_MONTH_OF[p.m - 1];
  })();
  const cmpLabel = d.pct_change == null ? '' : `${cmpSign}${Math.abs(d.pct_change)}% ${prevMonthName}дан`;

  const heroBook = (d.top_books && d.top_books[0]) || null;
  const heroCover = heroBook ? esc((heroBook.title || '?')[0]) : '?';

  // Insight cards
  const insights = [];
  if (d.top_day) {
    const wd = _weekdayOf(d.top_day.date) || d.top_day.weekday || '';
    const label = _formatDate(d.top_day.date);
    insights.push({
      icon: '🏆', lbl: 'Ең көп оқыған күн',
      val: `<span style="color:#8B5E34;">${d.top_day.pages} бет</span> · ${label}`,
      meta: wd
    });
  }
  if (d.longest_session) {
    const lsDate = _formatDate(d.longest_session.date);
    insights.push({
      icon: '⚡', lbl: 'Ең ұзақ сессия',
      val: `<span style="color:#8B5E34;">${esc(d.longest_session.text)}</span> · ${lsDate}`,
      meta: 'бір отырыста'
    });
  }
  if (d.peak_hour != null) {
    const peak = d.peak_hour;
    const lbl = _peakLabel(peak);
    const endHr = Math.min(peak + 2, 23);
    insights.push({
      icon: '🌙', lbl: 'Қашан көп оқыдың',
      val: `${lbl} <span style="color:#8B5E34;">${String(peak).padStart(2,'0')}:00 — ${String(endHr).padStart(2,'0')}:00</span>`,
      meta: ''
    });
  }
  const insightsHtml = insights.map(i => `
    <div style="background:#fff;border:.5px solid rgba(28,26,22,.08);border-radius:12px;padding:14px 16px;display:flex;align-items:center;gap:14px;">
      <div style="width:42px;height:42px;border-radius:11px;flex-shrink:0;background:linear-gradient(135deg,rgba(201,169,110,.25),rgba(139,94,52,.08));display:flex;align-items:center;justify-content:center;font-size:20px;">${i.icon}</div>
      <div style="flex:1;min-width:0;">
        <div style="font-size:12px;color:rgba(28,26,22,.55);font-weight:500;margin-bottom:3px;">${esc(i.lbl)}</div>
        <div style="font-family:'PT Serif',Georgia,serif;font-size:15px;font-weight:700;color:#1C1A16;line-height:1.25;">${i.val}</div>
        ${i.meta ? `<div style="font-size:11px;color:rgba(28,26,22,.55);margin-top:3px;font-family:'Cormorant Garamond',serif;font-style:italic;">${esc(i.meta)}</div>` : ''}
      </div>
    </div>
  `).join('');

  return `
    <div style="width:540px;height:960px;background:linear-gradient(160deg,#FBF7EF 0%,#F1E9D8 100%);padding:36px 32px;font-family:Onest,sans-serif;color:#1C1A16;box-sizing:border-box;position:relative;overflow:hidden;">
      <div style="position:absolute;top:-60px;right:-60px;width:280px;height:280px;background:radial-gradient(circle,rgba(233,169,73,.2) 0%,transparent 65%);pointer-events:none;"></div>
      <div style="position:absolute;bottom:-80px;left:-80px;width:240px;height:240px;background:radial-gradient(circle,rgba(201,169,110,.15) 0%,transparent 65%);pointer-events:none;"></div>

      <!-- Brand -->
      <div style="font-size:11px;letter-spacing:2.5px;color:#8B5E34;font-weight:600;margin-bottom:8px;position:relative;">PARAQTA · оқу журналы</div>

      <!-- Month + tagline -->
      <div style="font-family:'PT Serif',Georgia,serif;font-size:38px;font-weight:700;color:#1C1A16;line-height:1;position:relative;">${esc(d.month_name)} <span style="color:#8B5E34;">${d.year}</span></div>
      <div style="font-family:'Cormorant Garamond',serif;font-style:italic;font-size:16px;color:rgba(28,26,22,.55);margin-top:7px;position:relative;">шамың айдың әр аптасында жанды</div>

      <!-- Hero: candle + pages -->
      <div style="display:flex;align-items:center;gap:20px;margin:26px 0 22px;position:relative;">
        <div style="width:110px;height:140px;flex-shrink:0;position:relative;display:flex;align-items:flex-end;justify-content:center;">
          <!-- Outer soft halo (артқы фон) — таза сары fade, қара араласпайды -->
          <div style="position:absolute;top:-20px;left:50%;transform:translateX(-50%);width:200px;height:200px;background:radial-gradient(circle,rgba(255,200,90,.28) 0%,rgba(255,200,90,.1) 40%,rgba(255,200,90,0) 65%);pointer-events:none;z-index:0;"></div>
          <!-- Inner warm glow (артқы фон, шам алдында емес) — таза сары fade -->
          <div style="position:absolute;top:-5px;left:50%;transform:translateX(-50%);width:130px;height:130px;background:radial-gradient(circle,rgba(255,220,120,.55) 0%,rgba(255,210,100,.22) 35%,rgba(255,220,120,0) 65%);pointer-events:none;z-index:1;"></div>
          ${CANDLE_PNG_SVG}
        </div>
        <div style="flex:1;">
          <div style="font-family:'PT Serif',Georgia,serif;font-size:72px;font-weight:700;color:#8B5E34;line-height:1;">${d.pages}</div>
          <div style="font-size:15px;color:rgba(28,26,22,.55);margin-top:6px;font-weight:600;">бет</div>
          ${d.pct_change != null ? `<div style="display:inline-flex;align-items:center;gap:5px;margin-top:12px;padding:5px 12px;background:${cmpBg};border-radius:999px;font-size:12px;font-weight:700;color:${cmpColor};">${esc(cmpLabel)}</div>` : ''}
        </div>
      </div>

      <!-- Stats grid -->
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:22px;padding:18px 0;border-top:.5px solid rgba(139,94,52,.22);border-bottom:.5px solid rgba(139,94,52,.22);position:relative;">
        <div style="text-align:center;">
          <div style="font-family:'PT Serif',Georgia,serif;font-size:26px;font-weight:700;color:#1C1A16;line-height:1;">${esc(d.time_text || '0м')}</div>
          <div style="font-size:11px;color:rgba(28,26,22,.55);margin-top:6px;font-weight:600;">уақыт</div>
        </div>
        <div style="text-align:center;">
          <div style="font-family:'PT Serif',Georgia,serif;font-size:26px;font-weight:700;color:#1C1A16;line-height:1;">${d.books}</div>
          <div style="font-size:11px;color:rgba(28,26,22,.55);margin-top:6px;font-weight:600;">кітап</div>
        </div>
        <div style="text-align:center;">
          <div style="font-family:'PT Serif',Georgia,serif;font-size:26px;font-weight:700;color:#1C1A16;line-height:1;">${d.active_days}<small style="font-size:13px;font-family:Onest,sans-serif;font-weight:600;">/${d.days_in_month}</small></div>
          <div style="font-size:11px;color:rgba(28,26,22,.55);margin-top:6px;font-weight:600;">белсенді күн</div>
        </div>
      </div>

      ${heroBook ? `
      <!-- Book of month -->
      <div style="background:#fff;border:.5px solid rgba(28,26,22,.08);border-radius:14px;padding:14px;display:flex;align-items:center;gap:14px;margin-bottom:18px;position:relative;">
        <div style="width:54px;height:78px;flex-shrink:0;border-radius:6px;background:linear-gradient(135deg,#C9A96E,#8B5E34);display:flex;align-items:center;justify-content:center;color:#fff;font-family:'PT Serif',Georgia,serif;font-size:22px;font-weight:700;box-shadow:0 4px 12px rgba(139,94,52,.18);">${heroCover}</div>
        <div style="flex:1;min-width:0;">
          <div style="font-size:10.5px;letter-spacing:.5px;color:#8B5E34;font-weight:600;margin-bottom:4px;">Айдың кітабы</div>
          <div style="font-family:'PT Serif',Georgia,serif;font-size:17px;font-weight:700;color:#1C1A16;line-height:1.25;margin-bottom:3px;">«${esc(heroBook.title)}»</div>
          ${heroBook.author ? `<div style="font-size:12px;color:rgba(28,26,22,.55);font-family:'Cormorant Garamond',serif;font-style:italic;">${esc(heroBook.author)}</div>` : ''}
        </div>
        <div style="font-family:'PT Serif',Georgia,serif;font-size:22px;font-weight:700;color:#8B5E34;">${heroBook.pages}</div>
      </div>` : ''}

      <!-- Insights -->
      ${insightsHtml ? `
      <div style="font-family:'PT Serif',Georgia,serif;font-size:13px;color:#8B5E34;font-weight:600;margin:0 4px 10px;position:relative;">Айдың сәттері</div>
      <div style="display:flex;flex-direction:column;gap:8px;position:relative;">${insightsHtml}</div>` : ''}

      <!-- Footer -->
      <div style="position:absolute;bottom:24px;left:0;right:0;text-align:center;font-size:12px;color:rgba(28,26,22,.55);font-weight:600;letter-spacing:1px;">paraqta.kz</div>
    </div>
  `;
}

function _showJandosConversionModal() {
  // Stage 7.5 launch: Сурет жасап бөліскен соң — Жан дос-қа conversion modal
  // (тегін user-ге ғана).
  const existing = document.querySelector('[data-modal="jandos-conv"]');
  if (existing) return;
  const overlay = document.createElement('div');
  overlay.dataset.modal = 'jandos-conv';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(28,26,22,.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:24px;animation:fadeIn .3s ease;';
  overlay.innerHTML = `
    <div style="background:linear-gradient(160deg,#FBF7EF 0%,#F1E9D8 100%);border-radius:20px;padding:28px 24px 24px;max-width:340px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(28,26,22,.3);position:relative;">
      <button data-action="close-jandos-conv" style="position:absolute;top:12px;right:12px;width:32px;height:32px;border-radius:50%;border:none;background:rgba(28,26,22,.05);cursor:pointer;font-size:14px;color:rgba(28,26,22,.55);">✕</button>
      <div style="font-size:42px;margin-bottom:10px;">🕯</div>
      <div style="font-family:'PT Serif',Georgia,serif;font-size:20px;font-weight:700;color:#1C1A16;line-height:1.25;margin-bottom:8px;">Ұнады ма?</div>
      <div style="font-family:'Cormorant Garamond',serif;font-style:italic;font-size:14px;color:rgba(28,26,22,.65);line-height:1.5;margin-bottom:18px;">
        Әр айдың 1-күні алдыңғы айдың<br>есебі автоматты дайын тұрады.<br>
        <span style="color:#8B5E34;font-style:normal;font-family:Onest,sans-serif;font-weight:500;font-size:13px;display:block;margin-top:8px;">Тек оқисың — қалғанын біз ойлаймыз.</span>
      </div>
      <div style="display:flex;flex-direction:column;gap:8px;">
        <button data-action="open-jandos-from-conv" style="padding:12px 20px;background:#8B5E34;color:#fff;border:none;border-radius:999px;font-size:13px;font-weight:700;cursor:pointer;font-family:Onest,sans-serif;">PARAQTA-ның Жан досы бол · 690₸/ай →</button>
        <button data-action="close-jandos-conv" style="padding:10px;background:transparent;color:rgba(28,26,22,.55);border:none;font-size:12px;font-weight:500;cursor:pointer;font-family:Onest,sans-serif;">Кейінірек</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);
  overlay.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset?.action;
    if (action === 'close-jandos-conv' || e.target === overlay) {
      overlay.remove();
    } else if (action === 'open-jandos-from-conv') {
      overlay.remove();
      try { show('jandos'); } catch (_) {}
    }
  });
}

export async function shareMonthlyWrapped() {
  const r = root();
  if (!r || !_state.data) return;
  toast('🎨 Сурет жасалуда…');

  // Build off-screen composition in Stories aspect ratio (9:16)
  const wrap = document.createElement('div');
  wrap.style.cssText = 'position:fixed;left:-99999px;top:0;z-index:-1;pointer-events:none;';
  wrap.innerHTML = _buildPngComposition(_state.data);
  document.body.appendChild(wrap);
  const composition = wrap.firstElementChild;

  try {
    const mod = await import('html2canvas');
    const html2canvas = mod.default || mod;
    const canvas = await html2canvas(composition, {
      backgroundColor: '#FBF7EF',
      scale: 2,                // 540×960 × 2 = 1080×1920 (Stories full HD)
      useCORS: true,
      logging: false,
      width: 540,
      height: 960,
      windowWidth: 540,
      windowHeight: 960,
    });
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
    if (!blob) {
      toast('Сурет жасалмады');
      return;
    }
    const filename = `paraqta-wrapped-${_state.year}-${String(_state.month).padStart(2, '0')}.png`;
    const file = new File([blob], filename, { type: 'image/png' });
    let shared = false;
    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({
          files: [file],
          title: 'PARAQTA · Айлық есеп',
          text: `${_state.data?.month_name || ''} айының есебі — paraqta.kz`,
        });
        shared = true;
      } catch (e) {
        if (e?.name === 'AbortError') return;
      }
    }
    if (!shared) {
      // Fallback — download
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast('💾 Сурет жүктелді');
    }
    // Stage 7.5 launch — non-premium user shared/downloaded → show Жан дос conversion modal
    if (_state.isPromo) {
      setTimeout(() => _showJandosConversionModal(), 800);
    }
  } catch (e) {
    console.error('shareMonthlyWrapped failed', e);
    toast('Сурет жасалмады — қайталап көрейік');
  } finally {
    try { wrap.remove(); } catch (_) {}
  }
}
